import { View } from "react-native";

type Props = {
  children: React.ReactNode;
  glass?: boolean;
};

/**
 * Passthrough wrapper — the shared animated background and glass card
 * are now rendered once in OnboardingNavigator.
 */
export default function OnboardingShell({ children }: Props) {
  return <View style={{ flex: 1 }}>{children}</View>;
}
